import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
import { SectionReveal } from '../ui/SectionReveal';
const forWho = ['Personas con Diabetes Tipo 2 o Prediabetes que buscan un enfoque natural complementario.', "Quienes están cansados de sentirse fatigados y con 'neblina mental' después de comer.", 'Hombres y mujeres que quieren ver resultados reales en su glucómetro en solo una semana.', 'Quienes buscan una guía directa, sin tecnicismos médicos aburridos.'];
const notForWho = ["Personas que buscan una 'cura milagrosa' para dejar sus medicamentos sin supervisión médica.", 'Quienes no están dispuestos a realizar ajustes mínimos en sus hábitos diarios.', 'Personas que no sufren de desequilibrios en sus niveles de azúcar.'];
export function AudienceSection() {
  return <SectionReveal bgColor="mint" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A1A2E] mb-4" data-id="element-4">
            ¿Es este plan para ti?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-5">
            Queremos asegurarnos de que obtengas los resultados que mereces.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-6">
          {/* For Who */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-[#10B981]" data-id="element-7">
            <h3 className="text-2xl font-bold text-[#1A1A2E] mb-8 flex items-center gap-3" data-id="element-8">
              <span className="bg-[#F0FDF4] text-[#10B981] p-2 rounded-lg" data-id="element-9">
                <CheckCircle2 className="w-6 h-6" data-id="element-10" />
              </span>
              Para quién SÍ es:
            </h3>
            <ul className="space-y-6" data-id="element-11">
              {forWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-12">
                  <CheckCircle2 className="w-6 h-6 text-[#10B981] shrink-0 mt-0.5" data-id="element-13" />
                  <span className="text-gray-700 font-medium leading-relaxed" data-id="element-14">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Who */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-red-500" data-id="element-15">
            <h3 className="text-2xl font-bold text-[#1A1A2E] mb-8 flex items-center gap-3" data-id="element-16">
              <span className="bg-red-50 text-red-500 p-2 rounded-lg" data-id="element-17">
                <XCircle className="w-6 h-6" data-id="element-18" />
              </span>
              Para quién NO es:
            </h3>
            <ul className="space-y-6" data-id="element-19">
              {notForWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-20">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-21" />
                  <span className="text-gray-700 font-medium leading-relaxed" data-id="element-22">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </SectionReveal>;
}